module.exports = __webpack_public_path__ + "fb292e1d4a99645270e1ec95507ad976.fbx";